module.exports = __webpack_public_path__ + "img/personal_icon_stock@2x.b41aaa47.png";